import { render, staticRenderFns } from "./SportsSoccer.vue?vue&type=template&id=67c0d4a8&"
import script from "./SportsSoccer.vue?vue&type=script&lang=js&"
export * from "./SportsSoccer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports